import React from 'react';
import { Row, Form, Col, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import SettingsDropdown from '../../../../components/SettingsDropdown/SettingsDropdown';

// import Typography from '@material-ui/core/Typography';
import './UserRoleTableView.css';
import { DateConvert } from '../../../../utils/TimesheetManagement';


const useStyles = makeStyles({
    root: {
        minWidth: 275,
        overflow: 'visible'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

const UserRoleTableView = ({
    role,
    handleViewClick,
    handleEditClicked,
    handleClickDelete,
    callback,
    isEditable,
    isDeletable,
}) => {
    const classes = useStyles();

    return (
        <div onClick={(event) => {
            const settingsDropDown = event.target.closest('#settings-dropdown');
            if (!settingsDropDown) {
                callback(role)
            }
        }} onKeyDown={() => { }} role="button" tabIndex={0}>
            <Card className={classes.root}

            >
                <CardContent>
                    <Row className="p-0">
                        <Col xs="10"
                            onClick={() => {
                                callback(role);
                            }}
                        >
                            <Form.Group className="mb-0" controlId="formBasicServiceCity">
                                <Image
                                    className="mr-2 align-top"
                                    src={`${process.env.PUBLIC_URL}/assets/svg-icons/user-roles-red-icon.svg`}
                                />
                                <label >
                                    <strong>{role.rolename}</strong>
                                    <p>{DateConvert(role.updatedAt)}</p>
                                </label>
                            </Form.Group>

                        </Col>
                        <Col xs="1">
                            <span className="ellipse__role__mobile">
                                <SettingsDropdown
                                    identifier={role._id}
                                    handleViewClick={handleViewClick}
                                    handleEditClicked={handleEditClicked}
                                    handleClickDelete={handleClickDelete}
                                    isEditable={isEditable}
                                    isDeletable={isDeletable}
                                />
                            </span>
                        </Col>
                    </Row>
                </CardContent>
            </Card >

        </div>
    )
};

UserRoleTableView.propTypes = {
    role: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    handleViewClick: PropTypes.func.isRequired,
    handleEditClicked: PropTypes.func.isRequired,
    handleClickDelete: PropTypes.func.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isDeletable: PropTypes.bool.isRequired,
};

export default UserRoleTableView
